import { Card, CardContent, CardFooter } from "./ui/card";
import { Button } from "./ui/button";
import { Calendar } from "lucide-react";
import { Link } from "react-router-dom";

export function DoctorCard({
  name,
  specialty,
  qualifications,
  experience,
  image,
  href,
  hospitalDoctorId,
}) {
  return (
<Card className="flex flex-col h-full p-4 text-center bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-300">
      {/* IMAGE */}
      <Link to={href} className="block group mb-4">
       <div className="relative w-full h-72 bg-gray-100 flex items-center justify-center overflow-hidden rounded-lg"> 
            <img
            src={image || "/placeholder.svg"}
            alt={name}
            width={300}
            height={300}
            loading="lazy"
            className="object-contain w-full h-full p-2 transition-transform duration-300 group-hover:scale-105"
          />
        </div>
      </Link>

      {/* CONTENT */}
       <CardContent className="p-0 flex-1 flex flex-col items-center">
          <Link to={href} className="hover:text-primary transition-colors">
          <h3 className="text-lg font-semibold text-primary">
            {name}
          </h3>
        </Link>

        <p className="text-sm text-gray-700 mt-1">
          {specialty}
        </p>

        {qualifications && (
          <p className="text-sm text-muted-foreground mt-1">
            {qualifications}
          </p>
        )}

        {experience && (
          <p className="text-xs text-muted-foreground mt-1">
            {experience}
          </p>
        )}
      </CardContent>

         <CardFooter className="p-0 pt-4 mt-auto w-full">
          {hospitalDoctorId ? (
          <Button
            asChild
            className="w-full bg-primary text-white rounded-md hover:bg-primary/90"
          >
            <Link to={`/hospital-visit?doctorid=${hospitalDoctorId}`}>
              Book an Appointment
            </Link>
          </Button>
        ) : (
          <Button className="w-full" disabled>
            Book an Appointment
          </Button>
        )}
      </CardFooter>

    </Card>
  );
}